import React, { useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

import { Select } from '../../1elements';
import { SEARCH_OPTIONS } from '../../../consts/g-map-search';
import { isAllowedToView } from '../../../services/permissions/permissionHelper';

const verticalMenuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%'
  }
};

const disabledVerticalMenuItemSx = {
  ...verticalMenuItemSx,
  '&.Mui-disabled': {
    pointerEvents: 'auto'
  }
};

const MapSearchOptionDropDown = ({ value, onChange, className }) => {
  const canUseExecutive = useMemo(() => {
    return !!isAllowedToView('executive');
  }, []);

  useEffect(() => {
    if (value === SEARCH_OPTIONS.EXECUTIVE && !canUseExecutive) {
      onChange?.({ target: { value: SEARCH_OPTIONS.DEFAULT } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canUseExecutive]);

  const options = useMemo(
    () => [
      {
        value: SEARCH_OPTIONS.DEFAULT,
        text: 'Search',
        hint: 'Places/Account',
        disabled: false
      },
      {
        value: SEARCH_OPTIONS.ZONE,
        text: 'Zones',
        hint: 'Search By Geo Zone',
        disabled: false
      },
      {
        value: SEARCH_OPTIONS.EXECUTIVE,
        text: 'Executive',
        hint: canUseExecutive ? 'Executive Map View' : 'You do not have permission (executive.view)',
        disabled: !canUseExecutive
      },
      {
        value: SEARCH_OPTIONS.HEATMAP,
        text: 'Heatmaps',
        hint: 'Heatmaps & Clusters',
        disabled: false
      },
      {
        value: SEARCH_OPTIONS.PEOPLE,
        text: 'People',
        hint: 'This feature is coming soon!',
        disabled: true
      },
      {
        value: SEARCH_OPTIONS.SERVICE,
        text: 'Service',
        hint: 'This feature is coming soon!',
        disabled: true
      }
    ],
    [canUseExecutive]
  );

  return (
    <Box className={className} sx={(theme) => ({
      boxShadow: '0px 0px 6px #00000029',
      display: 'flex',
      height: '40px',
      minWidth: '160px',
      '& .MuiFormControl-root': {
        '& fieldset': { border: 'none' },
        '& .MuiSelect-select': {
          height: '30px',
          lineHeight: '30px',
          textAlign: 'left'
        },
        '& .MuiInputBase-root': {
          border: `1px solid ${theme.palette.quaternary.main}`,
          borderRadius: '5px',
          height: '40px'
        },
        '&:hover': {
          cursor: 'pointer',
          '& .MuiInputBase-root': {
            border: `1px solid ${theme.palette.secondary.accent}`
          }
        }
      }
    })}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
      >
        {options.map((option) =>
          option.disabled ? (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled
              sx={disabledVerticalMenuItemSx}
            >
              <Tooltip title={option.hint} describeChild>
                <span style={{ display: 'block', width: '100%' }}>
                  {option.text}
                </span>
              </Tooltip>
            </MenuItem>
          ) : (
            <MenuItem key={option.value} value={option.value} sx={verticalMenuItemSx}>
              {option.text}
            </MenuItem>
          )
        )}
      </Select>
    </Box>
  );
};

export default MapSearchOptionDropDown;
